export const PAGE_KEY = 'attendance-admin-legal-alerts-mexico-colaborador';
